import { escalaColumns } from '../../../components/escalaColumns'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { MinhaEscalaActionsCell } from './MinhaEscalaActionsCell'

const minhaEscalaColumns = escalaColumns({
  useQueryRequest,
  renderActions: (escala) => <MinhaEscalaActionsCell escala={escala} />,
})

export { minhaEscalaColumns }
